import * as actionType from '../../actions/@movie-analyzer/actionType';

const initialState = {
  castDetails: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SET_OUT_CAST_DETAILS:
      return {
        ...state,
        castDetails: action.value
      };
    case actionType.REMOVE_CAST_DETAILS:
      return {
        ...state,
        castDetails:null
      };
    default:
      return state;
  }
};

export default reducer;

